<template>
  <v-window-item :value="id" class="pt-1">
    <h-table
      v-for="table in tables"
      :key="table.id"
      :table="table"
      @create="$emit('create', $event)"
      @preview="$emit('preview', $event)"
      @edit="$emit('edit', $event)"
      @more="showMore"
    />
    <h-more
      v-model="more.show"
      v-bind="more"
      @book="$emit('book', $event)"
    />
  </v-window-item>
</template>

<script>
  import MoreContextMenu from '../MoreContextMenu'
  import HTable from './Table'

  export default {
    mixins: [
      MoreContextMenu,
    ],

    components: {
      HTable,
    },

    props: {
      id: {
        required: true,
        type: Number,
      },
    },

    computed: {
      tables () {
        return this.$store.getters['rummage/tables'](this.id)
      },
    },
  }
</script>
